module.exports = __webpack_public_path__ + "img/mastercard.602f7091.svg";